import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import type * as React from 'react';
import { Link as RouterLink } from '@tanstack/react-router';
import {
  CheckoutReturnView,
  type CheckoutReturnStatus,
} from '@/components/CheckoutReturnView';
import type { CheckoutProvider } from '@/api/billing';

const LinkAny = RouterLink as unknown as React.ElementType;

export interface CheckoutReturnSearch {
  status: CheckoutReturnStatus;
  provider: CheckoutProvider;
  attempt?: string;
  mock?: boolean;
  reason?: string;
}

function isStatus(value: unknown): value is CheckoutReturnStatus {
  return value === 'approved' || value === 'pending' || value === 'rejected' || value === 'cancelled';
}

function isProvider(value: unknown): value is CheckoutProvider {
  return value === 'mercadopago' || value === 'stripe';
}

export const Route = createFileRoute('/_authenticated/billing/checkout/return')({
  validateSearch: (search: Record<string, unknown>): CheckoutReturnSearch => {
    const status = isStatus(search.status) ? search.status : 'cancelled';
    const provider = isProvider(search.provider) ? search.provider : 'mercadopago';
    const attempt = typeof search.attempt === 'string' ? search.attempt : undefined;
    const mock = search.mock === true || search.mock === 'true' ? true : undefined;
    const reason = typeof search.reason === 'string' ? search.reason : undefined;
    return { status, provider, attempt, mock, reason };
  },
  component: CheckoutReturnPage,
});

function CheckoutReturnPage(): JSX.Element {
  const { status, provider, attempt, mock, reason } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component={LinkAny} to="/billing" underline="hover" color="inherit">
          Facturación
        </Link>
        <Typography color="text.primary">Resultado de suscripción</Typography>
      </Breadcrumbs>
      <CheckoutReturnView
        status={status}
        provider={provider}
        attempt={attempt}
        confirmMock={mock === true}
        reason={reason ?? null}
        onNavigate={(to) => navigate({ to })}
      />
    </Box>
  );
}
